import { render, staticRenderFns } from "./ReceiptsAdmin.vue?vue&type=template&id=67976aab&scoped=true&"
import script from "./ReceiptsAdmin.vue?vue&type=script&lang=ts&"
export * from "./ReceiptsAdmin.vue?vue&type=script&lang=ts&"
import style0 from "./ReceiptsAdmin.vue?vue&type=style&index=0&id=67976aab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67976aab",
  null
  
)

export default component.exports